import { getNetworkTrainList, getNetworkRailCombosetList } from 'services';
import { namespace } from '@/pages/railSetMeal/common/enum';

export default {
  namespace,
  state: {
    networkTrainList: [],
    networkRailCombosetList: [],
  },
  effects: {
    *getNetworkTrainList({ payload }, { call, put }) {
      const response = yield call(getNetworkTrainList, payload);
      if (response.data.state === '11') {
        yield put({
          type: 'setData',
          payload: {
            networkTrainList: response?.data?.list || [],
          }
        });
      }
    },
    *getNetworkRailCombosetList({ payload }, { call, put }) {
      const response = yield call(getNetworkRailCombosetList, payload);
      if (response.data.state === '11') {
        yield put({
          type: 'setData',
          payload: {
            networkRailCombosetList: response?.data?.list || [],
          }
        });
      }
    },
  },
  reducers: {
    setData(state, { payload }) {
      return {
        ...state,
        ...payload
      };
    },
  }
};
